import FileList from "./doc-list";

export default FileList;